import { render, staticRenderFns } from "./SystemTestPage.vue?vue&type=template&id=18717cf6&scoped=true&"
import script from "./SystemTestPage.vue?vue&type=script&lang=ts&"
export * from "./SystemTestPage.vue?vue&type=script&lang=ts&"
import style0 from "./SystemTestPage.vue?vue&type=style&index=0&id=18717cf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18717cf6",
  null
  
)

export default component.exports